module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av524-5e862c45fe12fa6c0106ba4cfa1c79db.jpg";